module.exports = __webpack_public_path__ + "img/select-metric-drawing.86403565.png";